var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: #fafafa;\n  @media (max-width: 768px) {\n    background-color: #fff;\n  }\n'], ['\n  background-color: #fafafa;\n  @media (max-width: 768px) {\n    background-color: #fff;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  padding-top: 24px;\n  padding-bottom: 24px;\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n'], ['\n  display: flex;\n  padding-top: 24px;\n  padding-bottom: 24px;\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  @media (max-width: 768px) {\n    width: 100%;\n    flex-direction: column;\n    &:first-of-type {\n      padding-bottom: 24px;\n      border-bottom: 1px solid #eee;\n      margin-bottom: 24px;\n      border-top: 1px solid #eee;\n      padding-top: 24px;\n    }\n  }\n  p {\n    margin-bottom: 0px;\n    @media (max-width: 768px) {\n        text-align: center;\n    }\n  }\n  img {\n    height: 40px;\n    padding-right: 24px;\n    @media (max-width: 768px) {\n      margin-bottom: 24px;\n      height: 50px;\n    }\n  }\n'], ['\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  @media (max-width: 768px) {\n    width: 100%;\n    flex-direction: column;\n    &:first-of-type {\n      padding-bottom: 24px;\n      border-bottom: 1px solid #eee;\n      margin-bottom: 24px;\n      border-top: 1px solid #eee;\n      padding-top: 24px;\n    }\n  }\n  p {\n    margin-bottom: 0px;\n    @media (max-width: 768px) {\n        text-align: center;\n    }\n  }\n  img {\n    height: 40px;\n    padding-right: 24px;\n    @media (max-width: 768px) {\n      margin-bottom: 24px;\n      height: 50px;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import Wrapper from '../Wrapper';
var Background = styled.div(_templateObject);
var Container = styled.div(_templateObject2);
var LogoContainer = styled.div(_templateObject3);

var FooterLogos = function FooterLogos(props) {
  var copywriter = props.copywriter,
      underwriter = props.underwriter,
      address = props.address,
      showOmart = props.showOmart;
  return React.createElement(Background, null, React.createElement(Wrapper, null, React.createElement(Container, null, React.createElement(LogoContainer, null, React.createElement('img', {
    src: underwriter.logo
  }), React.createElement('p', {
    dangerouslySetInnerHTML: {
      __html: underwriter.info
    }
  })), React.createElement(LogoContainer, null, React.createElement('img', {
    src: copywriter.logo
  }), React.createElement('p', {
    dangerouslySetInnerHTML: {
      __html: copywriter.info
    }
  })))));
};

export default FooterLogos;